export default function Component({processing}) {
    return (
        <div className="subplayer-progress-bar">
            <div className="inner" style={{width: `${processing}%`}}>
                <span>{`${processing.toFixed(2)}%`}</span>
            </div>
        </div>
    )
}